import { FileTextOutlined } from "@ant-design/icons";
import { Switch, Typography } from "antd";
import React from "react";
import { formatCurrency } from "../../../../libs/utils";
import styles from "./ReceiptMultiInvoiceAllocation.module.scss";

const { Text } = Typography;

type OverpaymentCreditBannerProps = {
  availableCredit: number;
  applyCredit: boolean;
  disabled?: boolean;
  onApplyCreditChange: (applied: boolean) => void;
};

export const OverpaymentCreditBanner: React.FC<OverpaymentCreditBannerProps> = ({
  availableCredit,
  applyCredit,
  disabled,
  onApplyCreditChange,
}) => (
  <div className={styles.overpaymentCreditBanner}>
    <div className={styles.overpaymentCreditBannerContent}>
      <FileTextOutlined className={styles.overpaymentCreditBannerIcon} />
      <Text className={styles.overpaymentCreditBannerText}>
        Tenant has <strong>{formatCurrency(availableCredit)}</strong> overpayment credit available on this lease.
      </Text>
    </div>
    <div className={styles.overpaymentCreditBannerAction}>
      <Text className={styles.applyCreditLabel}>Apply credit</Text>
      <Switch checked={applyCredit} disabled={disabled} onChange={onApplyCreditChange} />
    </div>
  </div>
);
